/**
 * @name voteWord
 * @description Časuje české slovo hlas.
 *
 * @param {number} votesCount Počet hlasů.
 * @returns {string}
 */
const voteWord = (votesCount: number) => {
  let spelledWord;

  if (votesCount === 1) {
    spelledWord = 'hlas';
  } else if (votesCount > 1 && votesCount < 5) {
    spelledWord = 'hlasy';
  } else {
    spelledWord = 'hlasů';
  }

  return spelledWord;
};

export default voteWord;
